import { type FC, memo, useMemo } from 'react';
import type { GameV1 } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { getGameCover } from '@/helpers/cdn';
import { useCMSGameCovers } from '@/modules/common/hooks/useCMSGameCovers';
import { PlayButton } from '@/modules/game/components/PlayButton';
import { ScSmallGameCardBack, ScSmallGameCardInner } from './styled';

interface ISmallGameCardProps {
  game: GameV1;
  onPlayClick?: () => void;
}

export const SmallGameCard: FC<ISmallGameCardProps> = memo(({ game }) => {
  const { id, fullPath } = game;
  const { covers } = useCMSGameCovers();

  const url = useMemo(
    () => covers?.[id]?.cover?.url || getGameCover(id),
    [covers, id]
  );

  return (
    <ScSmallGameCardInner>
      <ImageComponent
        alt="cover"
        className="cover-image"
        fill
        loading="lazy"
        src={url}
      />
      <ScSmallGameCardBack>
        <PlayButton href={`/game/${fullPath}`} size={48} />
      </ScSmallGameCardBack>
    </ScSmallGameCardInner>
  );
});
